import studentMale from "../../image/authentication/userType/student-male.png";
import teacherMale from "../../image/authentication/userType/teacher-male.png";
import studentFemale from "../../image/authentication/userType/student-female.png";
import teacherFemale from "../../image/authentication/userType/teacher-female.png";

export const UserTypesAndGender = [
  {
    id: 1,
    title: "دانش‌آموز هستم!",
    image: studentMale,
    alt: "دانش‌آموز پسر",
    gender: 0, // male
    type: 1, // student
  },
  {
    id: 2,
    title: "معلم هستم!",
    image: teacherMale,
    alt: "معلم مرد",
    gender: 0, // male
    type: 2, // teacher
  },
  {
    id: 3,
    title: "دانش‌آموز هستم!",
    image: studentFemale,
    alt: "دانش‌آموز دختر",
    gender: 1, // female
    type: 1, // student
  },
  {
    id: 4,
    title: "معلم هستم!",
    image: teacherFemale,
    alt: "معلم خانم",
    gender: 1, // female
    type: 2, // teacher
  },
];
